var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcWarningPriority(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_97_39",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0.558105H0V24.5581H24V0.558105Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_97_39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3.05811C17.2467 3.05811 21.5 7.3114 21.5 12.5581C21.5 17.8048 17.2467 22.0581 12 22.0581C6.75329 22.0581 2.5 17.8048 2.5 12.5581C2.5 7.3114 6.75329 3.05811 12 3.05811Z",
    fill: "#CB0033",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5581C11.7348 15.5581 11.4804 15.6635 11.2929 15.851C11.1054 16.0385 11 16.2929 11 16.5581C11 16.8233 11.1054 17.0777 11.2929 17.2652C11.4804 17.4527 11.7348 17.5581 12 17.5581C12.2652 17.5581 12.5196 17.4527 12.7071 17.2652C12.8946 17.0777 13 16.8233 13 16.5581C13 16.2929 12.8946 16.0385 12.7071 15.851C12.5196 15.6635 12.2652 15.5581 12 15.5581ZM12 6.55811C11.7551 6.55814 11.5187 6.64806 11.3356 6.81082C11.1526 6.97358 11.0357 7.19785 11.007 7.44111L11 7.55811V13.5581C11.0003 13.813 11.0979 14.0581 11.2728 14.2435C11.4478 14.4288 11.687 14.5403 11.9414 14.5553C12.1958 14.5702 12.4464 14.4874 12.6418 14.3238C12.8373 14.1603 12.9629 13.9282 12.993 13.6751L13 13.5581V7.55811C13 7.29289 12.8946 7.03854 12.7071 6.851C12.5196 6.66346 12.2652 6.55811 12 6.55811Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarningPriority);
export default __webpack_public_path__ + "static/media/Ic_Warning_Priority.83fca87f66662ccdfc3a93326b52afb2.svg";
export { ForwardRef as ReactComponent };